<template>
	<div id="error" class="error">
		<div class="logo-container">
			<svgIcon icon-holder-class="logo" icon-id="nexon-logo" />
		</div>

		<img class="error-logo" src="@/images/error/logo-error.png" />

		<h1 class="heading-normal text-white text-center">
			{{ $t(`main.error.${returnErrorCode}`) }}
		</h1>
		<p class="error-desc text-center">{{ $t(`main.error.${returnErrorCode}-desc`) }}</p>

		<button class="btn btn-gradient back-to-home" @click="backToHome">
			{{ $t('main.home') }}
		</button>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
	name: 'Error',
	components: {
		svgIcon,
	},
	props: {},
	computed: {
		returnErrorCode() {
			return this.$route.query.error ? this.$route.query.error : 404;
		},
	},
	methods: {
		backToHome() {
			location.href = '/main/';
		},
	},
};
</script>
